module.exports = __webpack_public_path__ + "static/portillo_hot_dog-f925a4cedd05170a494bd9357ceb16f8.png";